var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table-view',{attrs:{"headers":_vm.tableFieldsTasks,"items":_vm.tasks,"sort-by":"createdAt","sort-desc":true,"page":1,"items-per-page":20,"loading":_vm.isDataLoading,"computed-fields":_vm.computedFieldsTasks,"show-select":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }